<style lang="less" scoped>
.btnbar{padding: 5px;width: 45px;height: 45px;    background: rgba(33,55,69,.5);border: none; border-radius: 0; margin: 0;
  span{display: flex;flex-direction: column; color: #23FFFC;
    i{font-size: 24px;}
  }
}
.btnbar:focus{background: #21B9BF !important;
  span{color: #fff}
}
.btnbar:hover{background: #21B9BF !important;
  span{color: #fff}
}
.cross{padding: 5px;width: 45px;height: 45px;    background: rgba(33,55,69,.5);border: none; border-radius: 0; margin: 0;
  span{display: flex;flex-direction: column; color: #23FFFC;
    i{font-size: 24px;}
  }
}
.cross:focus{background: #21B9BF !important;
  span{color: #fff}
}
.cross:hover{background: #21B9BF !important;
  span{color: #fff}
}
.toolbar{display: flex;flex-direction: column;border-radius: 5px;overflow: hidden;position: absolute;left: 2%;top: 100px;}
.crossbar{display: flex;border-radius: 5px;overflow: hidden;position: absolute;left: 5%;top:190px;}
.markbar{display: flex;border-radius: 5px;overflow: hidden;position: absolute;left: 5%;top:145px;}
/deep/.el-tooltip__popper, .is-dark {color: #23fffc!important; background: rgba(33, 55, 69, 0.5)!important;}
</style>

<template>
  <div>
    <div class="toolbar">
      <el-tooltip class="item" effect="dark" :content="group.label" placement="right" plain v-for="(group, index) in groups" :key="index">
        <el-button type="primary" class="btnbar" @click="onMeasure(group, index)">
          <span>
            <i :class="group.icon"></i>
          </span>
        </el-button>
      </el-tooltip>
    </div>

    <div class="crossbar" v-if="flag">
      <el-tooltip class="item" effect="dark" :content="group.label" placement="bottom" plain v-for="(group, index) in analysis" :key="index">
        <el-button type="primary" class="cross" @click="onMeasure(group, index)">
          <span>
            <i :class="group.icon"></i>
          </span>
        </el-button>
      </el-tooltip>
    </div>

    <div class="markbar" v-if="markflag">
      <el-tooltip class="item" effect="dark" :content="group.label" placement="bottom" plain v-for="(group, index) in markdata" :key="index">
        <el-button type="primary" class="cross" @click="onMeasure(group, index)">
          <span>
            <i :class="group.icon"></i>
          </span>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      //导航工具条
      groups:
      [
        {icon: 'iconfont icon-zuobiao', label: '坐标', function: 'Coordinates'},
        {icon: 'iconfont icon-weizhi', label: '标注', function: 'showMark'},
        {icon: 'iconfont icon-icon-chongdie', label: '空间分析', function: 'showCross'},
        {icon: 'iconfont icon-chakan', label: '属性查看', function: 'attributeQuery'},
        // {icon: 'iconfont icon-celiang', label: '测距', title: 'LineString', function: 'easureMent'},
        // {icon: 'iconfont icon-mianji', label: '测面', title: 'area', function: 'easureMent'},
        {icon: 'iconfont icon-yunshangchuan', label: '文件上传', title: 'upload', function: 'UploadFile'},
        {icon: 'el-icon-delete', label: '清除', title: 'delete', function: 'easureMent'},
        {icon: 'iconfont icon-toumingdu', label: '透明度设置', title: '', function: 'SetOpacity'}
      ],
      //空间分析工具条
      analysis:
      [
        {icon: 'iconfont icon-icon-chongdie', label: '缓冲区分析', title: 'Buffer', function: 'Buffer'},
        {icon: 'iconfont icon-yuanxing', label: '圆形空间分析', title: 'Circle', function: 'spatialQuery'},
        {icon: 'iconfont icon-icon-line-graph', label: '绘制折线', title: 'LineString', function: 'spatialQuery'},
        {icon: 'iconfont icon-duobianxing', label: '多边形空间分析', title: 'Polygon', function: 'spatialQuery'}
      ],
      //标注工具条
      markdata:
      [
        {icon: 'iconfont icon-double-circle-full', label: '点', title: 'Point', function: 'Mark'},
        {icon: 'iconfont icon-icon-line-graph', label: '线', title: 'LineString', function: 'easureMent'},
        {icon: 'iconfont icon-duobianxing', label: '面', title: 'area', function: 'easureMent'}
      ],
      flag: false,
      markflag: false
    }
  },
  methods:
  {
    //调用父组件方法
    onMeasure(arr, index)
    {
      this.$emit(arr.function, arr)
      this.current = index
    },
    //打开空间分析工具条
    showCross()
    {
      if (this.flag)
        this.flag = false
      else
        this.flag = true
    },
    //关闭空间分析工具条
    closeCross(show)
    {
      this.flag = show
    },
    //打开标注工具条
    showMark()
    {
      if (this.markflag)
        this.markflag = false
      else
        this.markflag = true
    },
    //关闭标注工具条
    closeMark(show)
    {
      this.markflag = show
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/ToolBar.vue